// extracted by mini-css-extract-plugin
export default {"loaderV2":"Loader_loaderV2__El3f-","backdrop":"Loader_backdrop__wrVf9","backdropDark":"Loader_backdropDark__nbVYD","progressContainer":"Loader_progressContainer__YRVFa"};